import React from "react";

function ArtworkCard(props) {
  const round = props.round;
  const items = props.gameData;
  let currItem = items[Object.keys(items)[round]];
  const url = currItem["thumbnail"] + "=w300-h300-p";
  let showMoreInfo = props.displayMoreInfo ? true : false;
  return (
    <div className="w-100 mt4 flex">
      <div className="w-50 dib">
        <div className="aspect-ratio aspect-ratio--1x1 mb4">
          <img
            className={`aspect-ratio--object cover bg-custom-dark br-pill fit-cover  ${
              showMoreInfo ? "pointer" : null
            }`}
            src={url}
            alt={currItem.title}
            onClick={() => {
              if (showMoreInfo) props.displayMoreInfo(round);
            }}
          />
        </div>
      </div>
      <div className="w-50 dib pl3">
        <h3 className="f6 pt0 mt0 mb2 limit-2-lines">{currItem.title}</h3>
        {currItem.author !== "null" ? (
          <p className="f6 pt0 mt0 mb2">{currItem.author}</p>
        ) : null}
        {currItem.date !== "null" ? (
          <p className="f6 pt0 mt0 mb2">{currItem.date}</p>
        ) : null}
        <p className="f6 pt0 mt0 mb2">{currItem.partner}</p>
      </div>
    </div>
  );
}

export default ArtworkCard;
